import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("OpusPublicationWidget", {
  title: "OPUS Publication",
  attributes: {
    mode: {
      title: "Display Mode",
      values: [
        { value: "id", title: "Single Publication (ID)" },
        { value: "author", title: "Publication List (Author Search)" },
      ],
    },
    opusId: {
      title: "OPUS ID",
      description:
        "Numeric ID of the publication in OPUS (e.g. 674). Found in the URL: opus-hshn.bsz-bw.de/frontdoor/index/index/docId/674",
    },
    authorName: {
      title: "Author Name",
      description:
        "First and last name of the author, e.g. 'John Doe'. An author search will be performed in OPUS.",
    },
  },
  properties: (widget) => {
    const mode = widget.get("mode");
    if (mode === "author") return ["mode", "authorName"];
    return ["mode", "opusId"];
  },
  initialContent: {
    mode: "id",
    opusId: "",
    authorName: "",
  },
});
